export interface Preference {
    id: number;
    name: string;
    is_active: boolean;
}

export const defaultPreference: Preference = {
    id: 0,
    name: '',
    is_active: true
};

export interface PreferenceFilters {
    name?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
